import React from 'react';

import { Navigate, Outlet } from 'react-router-dom';
import { USER_REFS } from '../utils/localStorage';
import paths from './paths';

const ProtectedRoutes = () => {
  const localStorageToken = localStorage.getItem(USER_REFS.ACCESS_TOKEN);

  return localStorageToken ? <Outlet /> : <Navigate to={paths.ROOT} replace />;
};

export default ProtectedRoutes;
